var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThumbDowncomponent = function SvgThumbDowncomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.75v-6A.75.75 0 0 0 4.5 3H3a.75.75 0 0 0-.75.75V9a.75.75 0 0 0 .75.75h2.25Zm0 0a3 3 0 0 1 3 3v.75a1.5 1.5 0 0 0 3 0V9.75h2.25a1.5 1.5 0 0 0 1.5-1.5l-.75-3.75c-.108-.46-.313-.855-.583-1.126-.27-.27-.592-.402-.917-.374H7.5a2.25 2.25 0 0 0-2.25 2.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgThumbDowncomponent;